import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import {
  FormControlLabel,
  Grid,
  Switch,
  Button,
} from "@material-ui/core";
import useFormHandlers from "../useFormHandlers";
import useHasPermissions from "../../../../hooks/useHasPermissions";

const PointOfSaleForm = ({
  entityID,
  entityType,
  settingValues,
  onRatesClicked,
  onPeripheralsClicked,
  onGPIOClicked,
}) => {
  const [deviceMode, setDeviceMode] = useState(
    settingValues?.devicemode?.toLowerCase()
  );
  const { hasPermissions } = useHasPermissions();
  const RatesViewPermission = hasPermissions(["rates.view"], false, entityID);
  const { values, errors, setFieldValue } = useFormik({
    initialValues: settingValues,
    enableReinitialize: true,
  });

  const { handleToggle, canRenderFieldByMode } = useFormHandlers(
    setFieldValue,
    settingValues,
    entityID,
    entityType
  );

  useEffect(() => {
    settingValues?.devicemode &&
      setDeviceMode(settingValues.devicemode.toLowerCase());
  }, [settingValues?.devicemode]);

  return (
    <>
      <Grid item xs={12} sm={6} md={7} lg={7} xl={7}>
        {canRenderFieldByMode("devicedisabled", deviceMode) && (
          <FormControlLabel
            control={
              <Switch
                name="devicedisabled"
                checked={values.devicedisabled}
                onChange={(e) => handleToggle(values, errors, e)}
              />
            }
            label="Lane Closed"
          />
        )}
      </Grid>
      
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            {canRenderFieldByMode("peripherals", deviceMode) && (
              <Button
                fullWidth
                variant="contained"
                onClick={onPeripheralsClicked}
                color="primary"
              >
                Peripherals
              </Button>
            )}
          </Grid>
          <Grid item xs={12} sm={4}>
            {canRenderFieldByMode("gpio", deviceMode) && (
              <Button
                fullWidth
                variant="contained"
                onClick={onGPIOClicked}
                color="primary"
              >
                GPIO
              </Button>
            )}
          </Grid>
          <Grid item xs={12} sm={4}>
            {canRenderFieldByMode("rates", deviceMode) && RatesViewPermission && (
              <Button
                fullWidth
                variant="contained"
                onClick={onRatesClicked}
                color="primary"
              >
                Rates
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

PointOfSaleForm.defaultProps = {
  settingValues: {},
  onRatesClicked: () => {},
  onPeripheralsClicked: () => {},
  onGPIOClicked: () => {},
};

export default PointOfSaleForm;